import Localization from "./config/localization";
import Network from "./config/network";
import User from "./config/user";

export default {
  bootstrap(networkHash, userHash, localizationHash) {
    // handle not logged in case and/or no network specified, where null is passed
    networkHash = networkHash || {};
    userHash = userHash || {};
    localizationHash = localizationHash || {};

    this.network = new Network(networkHash.id, networkHash.name);

    this.user = new User(userHash.id, userHash.first_name, userHash.last_name);

    this.localization = new Localization(
      localizationHash.advertiser_name_from_network,
      localizationHash.affiliate_name_from_network,
      localizationHash.advertiser_id_friendly_name,
      localizationHash.affiliate_id_friendly_name,
      localizationHash.advertiser_campaignid_name,
      localizationHash.advertiser_campaignid_friendly_name
    );
  }
};
